<template>
  <v-list-item>
    <v-list-item-avatar tile>
      <v-img
        :src="
          $vuetify.theme.dark
            ? require('@/assets/sunny.png')
            : require('@/assets/night.png')
        "
      ></v-img>
    </v-list-item-avatar>
    <v-switch
      class="mt-5"
      @click="switchMode"
      v-model="darkMode"
      inset
    ></v-switch>
  </v-list-item>
</template>

<script>
import { useUXState } from "@/composables/ux.js";
export default {
  setup() {
    const { darkMode } = useUXState();
    return { darkMode };
  },
  methods: {
    switchMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.darkMode = this.$vuetify.theme.dark;
    }
  }
};
</script>
